export default "__VITE_ASSET__D$NMupXa__"